import type {CSSObject} from "@emotion/react";
import type {JSX, ReactNode} from "react";
import {useFontSize} from "@/context/fontSizeChange";
import Reveal from "@/elements/Reveal";
import {StyledText, StyledUnderline, StyledWrapper} from "./styles";

interface TitleUnderlinedAnimatedProps {
  maxWidth?: string;
  underlinedLettersAmount?: number;
  children?: ReactNode;
  lineClamp?: number | string;
  wrapperStyles?: CSSObject;
  type?: string;
  styles?: CSSObject;
  underlineHeight?: number;
  hideUnderline?: boolean;
  isDangerousHTML?: boolean;
  textHTML?: string;
  as?: keyof JSX.IntrinsicElements;
  title?: string;
}

function TitleUnderlinedAnimated({
  maxWidth = "auto",
  underlinedLettersAmount = 3,
  children,
  lineClamp,
  wrapperStyles,
  type,
  styles,
  underlineHeight,
  hideUnderline = false,
  isDangerousHTML = false,
  textHTML,
  as = "h2",
  title,
}: TitleUnderlinedAnimatedProps) {
  const fontSizeContext = useFontSize();
  if (!fontSizeContext) {
    throw new Error("useFontSize doit être utilisé dans un FontSizeProvider");
  }
  const {fontSize} = fontSizeContext;

  return (
    <StyledWrapper wrapperStyles={wrapperStyles} maxWidth={maxWidth}>
      {isDangerousHTML ? (
        <StyledText
          as={as}
          lineClamp={lineClamp}
          type={type}
          styles={styles}
          title={title}
          dangerouslySetInnerHTML={{__html: textHTML as string}}
        />
      ) : (
        <StyledText
          as={as}
          lineClamp={lineClamp}
          type={type}
          styles={styles}
          title={title}
        >
          {children}
        </StyledText>
      )}

      <Reveal
        from={{width: "0"}}
        to={{width: "100%"}}
        duration={0.5}
        ease="linear"
        instantAfterFirst
      >
        {!hideUnderline && (
          <StyledUnderline
            height={underlineHeight}
            fontSize={fontSize}
            underlinedLettersAmount={underlinedLettersAmount}
          />
        )}
      </Reveal>
    </StyledWrapper>
  );
}
export default TitleUnderlinedAnimated;
